module.exports = __webpack_public_path__ + "img/ezdeal.f68a104a.svg";